var _style, _path, _path2, _path3, _path4, _g, _circle, _path5, _circle2, _circle3, _circle4, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNotFound = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "not-found_svg__Layer_1",
  viewBox: "0 0 999 391"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4AB9BF",
  d: "M164.9 176.2h-16c-2.2 0-4 1.8-4 4v32.1c0 2.2 1.8 4 4 4H173c2.2 0 4-1.8 4-4v-24l-12.1-12.1zm4 32.1h-16v-4h16v4zm0-8h-16v-4h16v4zm-6-10v-11l11 11h-11zm676.7-14h-16c-2.2 0-4 1.8-4 4v32.1c0 2.2 1.8 4 4 4h24.1c2.2 0 4-1.8 4-4v-24l-12.1-12.1zm4 32.1h-16v-4h16v4zm0-8h-16v-4h16v4zm-6-10v-11l11 11h-11z",
  opacity: 0.3
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M263.3 354.8h30v30h-30v-30z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#4CBAC0",
  d: "M263 386.1h6.5v-19.6H263v19.6zm36-18c0-1.8-1.5-3.3-3.3-3.3h-10.3l1.5-7.5v-.5c0-.7-.3-1.3-.7-1.8l-1.8-1.6-10.6 10.8c-.7.5-1 1.3-1 2.3v16.4c0 1.8 1.5 3.3 3.3 3.3h14.7c1.3 0 2.5-.8 2.9-2l4.9-11.6c.3-.3.3-.7.3-1.1v-3.4h.1zM711.8 33.5h6.5V13.8h-6.5v19.7zm36-18c0-1.8-1.5-3.3-3.3-3.3h-10.3l1.5-7.5v-.5c0-.7-.3-1.3-.7-1.8L733.2.8l-10.6 10.8c-.7.5-1 1.3-1 2.3v16.4c0 1.8 1.5 3.3 3.3 3.3h14.7c1.3 0 2.5-.8 2.9-2l4.9-11.6c.3-.3.3-.7.3-1.1l.1-3.4z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#4AB9BF",
  d: "M30.7 318c0-1.7-1.3-3-3-3h-24c-1.7 0-3 1.3-3 3v18c0 1.7 1.3 3 3 3h21l6 6v-27zm-6 15.1h-18v-3h18v3zm0-4.5h-18v-3h18v3zm0-4.6h-18v-3h18v3zM997.8 60.3c0-1.7-1.3-3-3-3h-24c-1.7 0-3 1.3-3 3v18c0 1.7 1.3 3 3 3h21l6 6v-27zm-6 15h-18v-3h18v3zm0-4.5h-18v-3h18v3zm0-4.6h-18v-3h18v3z",
  opacity: 0.3
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "not-found_svg__search"
}, /*#__PURE__*/React.createElement("g", {
  id: "not-found_svg__Layer_2_1_"
}, /*#__PURE__*/React.createElement("g", {
  id: "not-found_svg__Layer_2-2",
  fill: "#4CBAC0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M970.2 320.7c1.2-1.2 2.3-2.3 2.9-2 .8.3 0 1.7-.5 2.5s-4.8 6.5-4.8 10.6c-.1 1.9.7 3.8 2.2 5 1.3 1 2.9 1.2 4.4.8 1.8-.5 3.3-2.3 5.1-4.7 2-2.5 4.8-5.8 6.9-5.8 2.7 0 2.8 1.7 3 3-6.3 1.1-9 6.2-9 9 .1 2.9 2.5 5.2 5.4 5.2 2.7 0 7.2-2.2 7.9-10.2h4.1v-4.2h-4.2c-.2-2.8-1.8-7-6.8-7-3.8 0-7 3.2-8.3 4.8-1 1.2-3.4 4.2-3.8 4.6-.4.4-1.1 1.3-1.8 1.3s-1.2-1.4-.6-3.2c.8-2.1 1.8-4.1 3.1-5.9 1.3-1.9 2.2-3.2 2.2-5.5.2-2.4-1.6-4.6-4-4.8h-.3c-1.7.1-3.3.9-4.6 2.1-.6.6-1.1 1.1-1.4 1.6l2.9 2.8zm15.6 19.6c-.7 0-1.2-.5-1.2-1.2 0-1 1.2-3.7 4.8-4.6-.5 4.5-2.4 5.8-3.6 5.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M299.2 3.8c0-2.1-1.7-3.8-3.8-3.8h-30.5c-2.1 0-3.8 1.7-3.8 3.8v22.9c0 2.1 1.7 3.8 3.8 3.8h26.7l7.6 7.6V3.8zm-7.6 19.1h-22.9v-3.8h22.9v3.8zm0-5.7h-22.9v-3.8h22.9v3.8zm0-5.8h-22.9V7.6h22.9v3.8zm457.7 344.8c0-2.1-1.7-3.8-3.8-3.8H715c-2.1 0-3.8 1.7-3.8 3.8v22.9c0 2.1 1.7 3.8 3.8 3.8h26.7l7.6 7.6v-34.3zm-7.6 19.1h-22.9v-3.8h22.9v3.8zm0-5.7h-22.9v-3.8h22.9v3.8zm0-5.8h-22.9V360h22.9v3.8z",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.3 70.5c1.2-1.2 2.3-2.3 2.9-2 .8.3 0 1.7-.5 2.5s-4.8 6.5-4.8 10.6c-.1 1.9.7 3.8 2.2 5 1.3 1 2.9 1.2 4.4.8 1.8-.5 3.3-2.3 5.1-4.7 2-2.5 4.8-5.8 6.9-5.8 2.7 0 2.8 1.7 3 3-6.3 1.1-9 6.2-9 9 .1 2.9 2.5 5.2 5.4 5.2 2.7 0 7.2-2.2 7.9-10.2h4.1v-4.2h-4.2c-.2-2.8-1.8-7-6.8-7-3.8 0-7 3.2-8.3 4.8-1 1.2-3.4 4.2-3.8 4.6S7.7 83.4 7 83.4s-1.2-1.4-.6-3.2c.8-2.1 1.8-4.1 3.1-5.9 1.3-1.9 2.2-3.2 2.2-5.5.2-2.4-1.6-4.6-4-4.8h-.3c-1.7.1-3.3.9-4.6 2.1-.6.6-1.1 1.1-1.4 1.6l2.9 2.8zm15.6 19.6c-.7 0-1.2-.5-1.2-1.2 0-1 1.2-3.7 4.8-4.6-.5 4.5-2.4 5.8-3.6 5.8z"
}))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  fill: "#EBF7F8",
  cx: 499,
  cy: 194.9,
  r: 127.6
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M615.4 318.6c-4.3 4.3-11.4 4.3-15.7 0l-59.4-59.4c-4.3-4.3-4.3-11.4 0-15.7 4.3-4.3 11.4-4.3 15.7 0l59.4 59.4c4.3 4.3 4.3 11.4 0 15.7z"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(-45.001 457.917 161.16)",
  fill: "#CCC",
  cx: 457.9,
  cy: 161.2,
  r: 94.2
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(-45.001 457.917 161.16)",
  fill: "#FFF",
  cx: 457.9,
  cy: 161.2,
  r: 78.6
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  fill: "#CCC",
  cx: 532.4,
  cy: 235.6,
  r: 11.1
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#4CBAC0",
  d: "M465.6 144.8c0-4.3-2.6-7.7-7.7-7.7-3.5 0-6.7 1.7-9.2 4.6l-3.8-3.4c3.4-3.8 7.9-6.6 13.7-6.6 8.1 0 13.4 4.9 13.4 12.8 0 10.5-12.9 14.7-11.6 25.9h-5.8c-1.7-12.5 11-17.1 11-25.6zm-12.7 37.4c0-3 2.1-5.1 4.8-5.1 2.6 0 4.8 2.1 4.8 5.1 0 2.9-2.1 5-4.8 5-2.6-.1-4.8-2.1-4.8-5z"
})));
export default SvgNotFound;